import {observable, computed, action} from 'mobx';
import moment from 'moment';

class DayOffViewModel {
  @observable json;
  @observable unit;
  @observable editable;
  @observable valid = true;

  constructor(json, editable=true) {
    this.json = json;
    this.json.maxHours = this.json.maxHours || parseFloat(this.json.cost);
    this.unit = this.guessUnit();
    this.editable = editable;
  }

  equalTo(other) {
    return this.json.date === other.json.date;
  }

  guessUnit() {
    if (this.json.work_day_length_in_seconds === this.json.cost_in_seconds) return 'full';
    if (this.json.work_day_length_in_seconds === this.json.cost_in_seconds * 2) return 'half';
    return 'custom';
  }

  @action updateUnit(unit) {
    this.unit = unit;

    switch (unit) {
      case 'full':
        this.updateHours(this.json.work_day_length_in_seconds / 3600);
        break;
      case 'half':
        this.updateHours((this.json.work_day_length_in_seconds / 3600) / 2);
        break;
      case 'custom':
      default:
        break;
    }
  }

  @action updateHours(value, valid=true) {
    this.json.cost_in_seconds = value * 3600;
    this.json.cost = value;
    this.valid = valid;
  }

  @computed get days() {
    return Math.round(this.json.cost_in_seconds * 100 / this.json.work_day_length_in_seconds) / 100;
  }

  @computed get hours() {
    return Math.round(this.json.cost_in_seconds * 100 / 3600) / 100;
  }

  @computed get hasHoliday() {
    return !!this.json.holiday;
  }

  @computed get hasFullDayHoliday() {
    return this.json.holiday_duration === 'full_day';
  }

  @computed get hasHalfDayHoliday() {
    return this.json.holiday_duration === 'half_day';
  }

  @computed get holidayName() {
    return this.json.holiday;
  }

  @computed get hasCompanyDayOff() {
    return this.json.day_off;
  }

  @computed get date() {
    return new Date(moment(this.json.date));
  }

  @computed get canUpdateHours() {
    return !this.hasCompanyDayOff && !this.hasFullDayHoliday && this.editable;
  }

  @computed get clickable() {
    return this.canUpdateHours;
  }
}

export default DayOffViewModel;
